import { useSelector } from 'react-redux';
import { Filter } from '../../Enum/Filters';
import { FilterValues } from '../../Store/Filter/state';
import { RootState } from '../../Store';
import { Period } from '../../Interface/Interest/Period';
import InterestUri from '../../Enum/InterestUri';

export interface FilterSelectionValues {
    labels: string[],
    properties: string[]
}

const useGetFilterValue = (type: Filter): string | string[] | number | number[] | Period[] =>
    useSelector<RootState, FilterValues>(state => state.filter.filterValues)[type];

export const useGetFilterSelectionValues = (section?: InterestUri): FilterSelectionValues => {
    const labels = section === InterestUri.PropertiesPerLabel ? useGetFilterValue(Filter.Labels) as string[] : [];
    const properties = section === InterestUri.PropertiesPerProperty
        ? useGetFilterValue(Filter.MortgageProperties) as string[]
        : [];

    return { labels, properties };
}

export default useGetFilterValue;
